import instance from '../../utils/API'

const axios = require('axios')
// ---------
// Actions
// ---------
const FETCH_START = 'redux/course/FETCH_START'
const FETCH_COMPLETE = 'redux/course/FETCH_COMPLETE'
const FETCH_ERROR = 'redux/course/FETCH_ERROR'
const CLEAR = 'redux/course/CLEAR'

const SET_LESSON_LOADING = 'redux/course/SET_LESSON_LOADING'
const SET_LESSON_COMPLETE = 'redux/course/SET_LESSON_COMPLETE'
const SET_ACTIVE_LESSON = 'redux/course/SET_ACTIVE_LESSON'
const SET_FINISH_LESSON = 'redux/course/SET_FINISH_LESSON'

// ---------
// Reducer
// ---------

const initialState = {
    course: {},
    userCourse: {},
    activeLesson : {},
    courseFinished: false,
    lessonSelected : false,
    lessonLoading: false,
    isError: false,
    isFetching: false,
    errorMessage: "",
}

const course = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return {
                ...state,
                isFetching: true,
            }
        case FETCH_ERROR:
            return {
                ...state,
                isFetching: false,
                isError: true,
                errorMessage: action.payload
            }
        case FETCH_COMPLETE:
            var completedLessonsAmount = action.userCoursesPayload.UserLessons.length
            var totalLessons = action.coursesPayload.lessons.length
            var lastCompleted
            action.coursesPayload.lessons.forEach(lesson =>{
                if(action.userCoursesPayload.UserLessons.some(userLesson => userLesson.lessonId == lesson.id)){
                    lastCompleted = lesson;
                }
            })
            var nextLectureIndex = action.coursesPayload.lessons.indexOf(lastCompleted) + 1

            if(completedLessonsAmount === totalLessons){
                return {
                    ...state,
                    course: action.coursesPayload,
                    userCourse: action.userCoursesPayload,
                    courseFinished: true,
                    lessonLoading: false,
                    isFetching: false,
                    isError: false
                }    
            } else if (completedLessonsAmount === 0){
                return {
                    ...state,
                    course: action.coursesPayload,
                    userCourse: action.userCoursesPayload,
                    courseFinished: false,
                    lessonSelected: false,
                    lessonLoading: false,
                    isFetching: false,
                    isError: false
                }    

            }else{
                return {
                    ...state,
                    course: action.coursesPayload,
                    userCourse: action.userCoursesPayload,
                    activeLesson: action.coursesPayload.lessons[nextLectureIndex],
                    courseFinished: false,
                    lessonSelected: true,
                    lessonLoading: false,
                    isFetching: false,
                    isError: false
                }    
            }


        case SET_LESSON_LOADING:
            return {
                ...state,
                lessonLoading: true,
                isError: false
            }

        case SET_LESSON_COMPLETE:
            return {
                ...state,
                lessonLoading: false,
                isError: false
            }

        case SET_ACTIVE_LESSON:
            var result
            if (state.course)
                result = state.course.lessons.filter(obj => obj.id === action.payload)[0];
            
            return {
                ...state,
                activeLesson: result,
                lessonSelected: true,
                lessonLoading: false,
                isError: false
            }

        case SET_FINISH_LESSON:
            var lessonIndex = state.course.lessons.findIndex(e => e.id == action.finishedLessonId)
            var newLesson = state.course.lessons[lessonIndex + 1]
            if(newLesson){
                return {
                    ...state,
                    activeLesson: newLesson,
                    userCourse: action.payload,
                    lessonSelected: true,
                    lessonLoading: false,
                    isError: false
                }
            }else{
                return {
                    ...state,
                    courseFinished: true,
                    userCourse: action.payload,
                    lessonSelected: false,
                    activeLesson: {},
                    lessonLoading: false,
                    isError: false
                }
            }

        case CLEAR:
            return initialState
        default:
            return state
    }
}

export default course

const setActiveLesson = (access_token, lessonId) => dispatch =>{
    
    dispatch({
        type: SET_LESSON_LOADING
    })

    dispatch({
        type: SET_ACTIVE_LESSON,
        payload: lessonId
    })

    dispatch({
        type: SET_LESSON_COMPLETE
    })
}

const setFinishLesson = (access_token, courseId, lessonId, lessonNotes="") => dispatch =>{
    
    dispatch({
        type: SET_LESSON_LOADING
    })
    instance(access_token).put("user-courses/0", 
                {
                    "courseId": courseId,
                    "lessonId": lessonId, 
                    "lessonNotes": lessonNotes
                })
                .then(function (response) {
                    if(response.data){
                        dispatch({
                                type: SET_FINISH_LESSON,
                                finishedLessonId: lessonId,
                                payload: response.data
                            })
                        dispatch({
                            type: SET_LESSON_COMPLETE
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
                
}


const getCourse = (access_token, id) => dispatch  => {

    dispatch({
        type: FETCH_START
    })

    axios.all([
        instance(access_token).get("courses/"+id), 
        instance(access_token).get("user-courses/"+id)
    ])
        .then(axios.spread((...responses) => {
            const responseCourses = responses[0]
            const responseUserCourses = responses[1]
            if (responseCourses) {
                dispatch({
                    type: FETCH_COMPLETE,
                    coursesPayload: responseCourses.data,
                    userCoursesPayload: responseUserCourses.data
                })
            }
        })).catch(errors => {
            dispatch({
                type: FETCH_ERROR,
                payload: errors.response
            })
        })

}

const clear = () => dispatch  => {
    dispatch({
        type: CLEAR
    })
}


export const courseActions = {
    getCourse,
    setActiveLesson,
    setFinishLesson,
    clear
}
